import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.backgroundColor};

  div {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    transform: none;
    text-align: center;
    gap: 24px;
    color: ${({ theme }) => theme.foregroundColor};

    > img {
      width: 60px;
      height: 60px;
    }

    > h2 {
      font-size: 24px;
      font-weight: 500;
      line-height: 32px;
      max-width: 260px;
    }

    > span {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: ${({ theme }) => theme.foregroundColor};

      > a {
        color: #4759f5;
        text-decoration: underline;
        cursor: pointer;
        font-size: 13px;
      }
    }
  }
`;
